import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { Space, Input, Popover, Popconfirm, Tag, Modal } from 'antd';
import axios from 'axios';
import config from '../../../config';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import FormCatDepense from './FormCatDepense';
import {
  NdoePage, NdoePageHeader, NdoeToolbar, NdoeActionButton,
  NdoeResponsiveTable, NdoeDataCard, NdoeStats, NdoeStatCard,
} from '../../../components/ndoe';

const CatDepenses = () => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [open, setOpen] = useState(false);
    const user = useSelector((state) => state.user?.currentUser);
    const isAdmin = user?.role === 'admin';

    // Fetch réutilisable : appelé au montage ET après chaque mutation (delete / création).
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/depenses/catDepenses`);
        setData(data);
        setLoading(false);
      } catch (error) {
        toast.error("Impossible de charger les catégories de dépenses.");
        setLoading(false);
      }
    };

    useEffect(() => {
      fetchData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [DOMAIN]);

    const handleDelete = async (id) => {
      try {
        await axios.delete(`${DOMAIN}/api/depenses/catDepenses/${id}`);
        toast.success("Catégorie supprimée.");
        fetchData();                 // refetch au lieu de recharger toute la page
      } catch (err) {
        toast.error(err?.response?.data?.message || err?.message || "Suppression impossible.");
      }
    };

    const columns = [
      { title: '#', dataIndex: 'id', key: 'id', render: (text, record, index) => index + 1, width: '3%' },
      {
        title: 'Nom de categorie',
        dataIndex: 'nom',
        key: 'nom_categorie',
        render: (text) => (
          <div>
            <Tag color={'blue'}>{text}</Tag>
          </div>
        ),
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        render: (text) => (
          <Tag color={'blue'}>{text}</Tag>
        ),
      },
      {
        title: 'Action',
        key: 'action',
        render: (text, record) => (
          <Space size="middle">
            {isAdmin &&
              <Popover title="Supprimer" trigger="hover">
                <Popconfirm
                  title="Êtes-vous sûr de vouloir supprimer?"
                  onConfirm={() => handleDelete(record.id_catDepense)}
                  okText="Oui"
                  cancelText="Non"
                >
                  <NdoeActionButton size="sm" variant="danger" icon={<DeleteOutlined />} iconOnly aria-label="Supprimer" />
                </Popconfirm>
              </Popover>
            }
          </Space>
        ),
      },
    ];

    // Carte mobile (remplace une ligne de tableau sur < 768px).
    const renderCard = (record) => (
      <NdoeDataCard
        title={record.nom}
        subtitle={record.description}
        badge={<Tag color="blue">Catégorie</Tag>}
        actions={
          isAdmin ? [
            <Popconfirm
              key="d"
              title="Êtes-vous sûr de vouloir supprimer?"
              onConfirm={() => handleDelete(record.id_catDepense)}
              okText="Oui"
              cancelText="Non"
            >
              <NdoeActionButton size="sm" variant="danger" icon={<DeleteOutlined />}>Suppr.</NdoeActionButton>
            </Popconfirm>,
          ] : null
        }
      />
    );

    const filteredData = data?.filter((item) =>
      item.nom?.toLowerCase().includes(searchValue.toLowerCase())
    );

  return (
    <NdoePage>
      <NdoePageHeader
        eyebrow="Dépenses"
        title="Liste de categorie de dépenses"
        subtitle="Gérer vos categorie de dépenses"
        actions={
          <NdoeActionButton variant="primary" icon={<PlusOutlined />} onClick={() => setOpen(true)}>
            Nouvelle catégorie
          </NdoeActionButton>
        }
      />

      <NdoeStats>
        <NdoeStatCard label="Total catégories" value={data?.length || 0} />
      </NdoeStats>

      <NdoeToolbar
        search={
          <Input.Search
            type="search"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="Recherche..."
            allowClear
          />
        }
      />

      <NdoeResponsiveTable
        data={filteredData}
        columns={columns}
        rowKey="id_catDepense"
        loading={loading}
        scroll={{ x: 'max-content' }}
        pagination={{ pageSize: 10 }}
        renderCard={renderCard}
        empty={{ icon: '🗂️', title: 'Aucune catégorie', text: 'Ajustez la recherche ou créez une catégorie.' }}
      />

      <Modal
        centered
        title="Ajouter une catégorie de dépenses"
        open={open}
        onCancel={() => setOpen(false)}
        width={600}
        footer={[]}
        destroyOnClose
      >
        <FormCatDepense fetchData={fetchData} closeModal={() => setOpen(false)} />
      </Modal>
    </NdoePage>
  )
}

export default CatDepenses
